/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Plusonesuptocount4Inputs */

const en_plusonesuptocount4 = /** @type {(inputs: Plusonesuptocount4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Up to ${i?.count}`)
};

const de_plusonesuptocount4 = /** @type {(inputs: Plusonesuptocount4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bis zu ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Up to {count}" |
*
* @param {Plusonesuptocount4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const plusonesuptocount4 = /** @type {((inputs: Plusonesuptocount4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plusonesuptocount4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plusonesuptocount4(inputs)
	return de_plusonesuptocount4(inputs)
});
export { plusonesuptocount4 as "plusOnesUpToCount" }